import { render, staticRenderFns } from "./WidgetReportSummary.vue?vue&type=template&id=4cdcfc1e&scoped=true&"
import script from "./WidgetReportSummary.vue?vue&type=script&lang=js&"
export * from "./WidgetReportSummary.vue?vue&type=script&lang=js&"
import style0 from "./WidgetReportSummary.vue?vue&type=style&index=0&id=4cdcfc1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdcfc1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cdcfc1e')) {
      api.createRecord('4cdcfc1e', component.options)
    } else {
      api.reload('4cdcfc1e', component.options)
    }
    module.hot.accept("./WidgetReportSummary.vue?vue&type=template&id=4cdcfc1e&scoped=true&", function () {
      api.rerender('4cdcfc1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetReportSummary.vue"
export default component.exports